import { render, staticRenderFns } from "./import-package-card.vue?vue&type=template&id=08f2a448&scoped=true&"
import script from "./import-package-card.vue?vue&type=script&lang=ts&"
export * from "./import-package-card.vue?vue&type=script&lang=ts&"
import style0 from "./import-package-card.vue?vue&type=style&index=0&id=08f2a448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2a448",
  null
  
)

export default component.exports